export default function() {
  ;(function($) {
    $(function() {
      $('.accordion-item:not(.no-drop) .accordion-head').click(function() {
        if (
          $(this)
            .next()
            .css('display') == 'block'
        ) {
          $(this)
            .next()
            .slideUp(150)
          $('svg', this).css({ transform: 'rotate(0)' })
        } else {
          $(this)
            .next()
            .slideDown(150)
          $('svg', this).css({ transform: 'rotate(-180deg)' })
        }
      })

      $('.mg-accordion').each(function(index) {
        const $accordionHead = $(
          '.accordion-item:not(.no-drop) .accordion-head',
          this
        )
        $accordionHead.eq(0).click()
      })
    })
  })(jQuery)
}



// WEBPACK FOOTER //
// ./src/js/partials/accordion.js